import React, { FC } from 'react';

import './BannerWithHistory.scss';
import { IBannerWithHistory } from './models';
import UmbracoImage from 'components/common/Image/UmbracoImage';
import InnerHtml from 'components/common/DangerouslySetInnerHtml';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Banner from '../Banner/Banner';

const BannerWithHistory: FC<IBannerWithHistory> = ({
  subHeading,
  backgroundImage,
  heading,
  productImageDesktop,
}) => {
  console.log('heading', heading);
  return (
    <div className="banner-with-history double-banner-container">
      <div className="double-banner double-banner__wide">
        <Banner
          title={{ boldText: heading }}
          large
          textWrapElement="h1"
          img={backgroundImage}
          alt={backgroundImage.altText}
        />
        <div className="double-banner__bottom">
          <div className="background">
            {productImageDesktop && (
              <UmbracoImage
                image={productImageDesktop}
                alt={productImageDesktop.altText}
                className="desktop"
                lazyLoad={false}
              />
            )}
          </div>
          <Row className="double-banner__content-bottom">
            <Col sm={12} md={12} className="text pb-4 pt-0 pl-4 pr-4 text-center">
              <InnerHtml html={subHeading} />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default BannerWithHistory;
